import React from 'react';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getDietAction } from '../../../services/request';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

import DietList from './diet/DietList';

export default function DietRecord() {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getDietAction(search, 'GET'));
  const optionsRequest = useQuery(getDietAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [diets, setDiets] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [allSeasons, setAllSeasons] = React.useState([]);
  const [allCamps, setAllCamps] = React.useState([]);
  const [allEvents, setAllEvents] = React.useState([]);
  const [allPeriods, setAllPeriods] = React.useState([]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  React.useEffect(() => {
    if (!loading && !error) {
      setDiets(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setAllSeasons(optionsRequest.payload.actions.GET.season.choices);
      setAllCamps(optionsRequest.payload.actions.GET.camps.choices);
      setAllEvents(optionsRequest.payload.actions.GET.events.choices);
      setAllPeriods(optionsRequest.payload.actions.GET.periods.choices);
    }
  }, [optionsRequest.loading]);

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setDiets(prev => prev.map(obj => obj.id === obj2.id ? obj2 : obj));
    } else if (method === 'delete') {
      setDiets(prev => prev.filter(obj => obj.id !== obj2.id));
    } else {
      setDiets(prev => [obj2, ...prev]);
    }

    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Box display="flex" justifyContent="center">
      </Box>
      <DietList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        diets={diets}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        allSeasons={allSeasons}
        allCamps={allCamps}
        allEvents={allEvents}
        allPeriods={allPeriods}
      />
    </>
  );
};
